import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Agences = () => {
  const sectorData = {
    title: "Agences",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Qu'elles soient digitales, RP ou en branding, les agences doivent émerger sur des marchés saturés et concurrentiels. Valoriser ses réalisations, produire des cas clients impactants, cibler les directions marketing ou communication avec des messages ROIstes et créatifs est essentiel pour capter l'attention et convertir.",
    name: "Agences",
    titleContext: "aux agences",
    responseContext: "des Agences",
    expertContext: "des Agences"
  };

  return <SectorPage sector={sectorData} />;
};

export default Agences; 